import * as pdfjsLib from 'pdfjs-dist'
import { CONFIG } from './config'

// Set up PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = new URL(
  'pdfjs-dist/build/pdf.worker.min.mjs',
  import.meta.url
).toString()

/** Validate uploaded file is actually a PDF */
export const validatePdf = (arrayBuffer) => {
  const header = new Uint8Array(arrayBuffer.slice(0, 5))
  return CONFIG.pdf.magic.every((byte, i) => header[i] === byte)
}

/** Extract text from PDF with layout preservation */
export async function extractTextFromPdf(arrayBuffer) {
  const pdf = await pdfjsLib.getDocument({ data: arrayBuffer }).promise
  const pagesText = []

  for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
    const page = await pdf.getPage(pageNum)
    const textContent = await page.getTextContent()
    const viewport = page.getViewport({ scale: 1.0 })

    const items = textContent.items
      .filter((item) => item.str?.trim())
      .map((item) => ({
        text: item.str,
        x: item.transform[4],
        y: viewport.height - item.transform[5],
        width: item.width,
      }))
      .sort((a, b) => {
        const yDiff = a.y - b.y
        return Math.abs(yDiff) > 5 ? yDiff : a.x - b.x
      })

    let pageText = ''
    let lastY = null,
      lastX = null,
      lastWidth = 0

    for (const item of items) {
      if (lastY !== null) {
        const yGap = item.y - lastY

        if (yGap > CONFIG.pdf.paragraphGap) {
          pageText += '\n\n'
          lastX = null
        } else if (yGap > CONFIG.pdf.lineGap) {
          pageText += '\n'
          lastX = null
        } else if (lastX !== null) {
          const xGap = item.x - (lastX + lastWidth)
          if (xGap > CONFIG.pdf.largeGap) pageText += '    '
          else if (xGap > CONFIG.pdf.smallGap) pageText += ' '
        }
      }

      pageText += item.text
      lastY = item.y
      lastX = item.x
      lastWidth = item.width || item.text.length * 5
    }

    pagesText.push(`${'='.repeat(60)}\nPage ${pageNum}\n${'='.repeat(60)}\n\n${pageText.trim()}`)
  }

  return { text: pagesText.join('\n\n'), pages: pdf.numPages }
}
